import _defineProperty from "/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as identityBase from './bases/identity.js';
import * as base2 from './bases/base2.js';
import * as base8 from './bases/base8.js';
import * as base10 from './bases/base10.js';
import * as base16 from './bases/base16.js';
import * as base32 from './bases/base32.js';
import * as base36 from './bases/base36.js';
import * as base58 from './bases/base58.js';
import * as base64 from './bases/base64.js';
import * as sha2 from './hashes/sha2.js';
import * as identity from './hashes/identity.js';
import * as raw from './codecs/raw.js';
import * as json from './codecs/json.js';
import { CID, hasher, digest, varint, bytes } from './index.js';

var bases = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, identityBase), base2), base8), base10), base16), base32), base36), base58), base64);

var hashes = _objectSpread(_objectSpread({}, sha2), identity);

var codecs = {
  raw: raw,
  json: json
};
export { CID, hasher, digest, varint, bytes, hashes, bases, codecs };